import { buildModelManager } from "../builder.js";
const DefaultShopifyPriceRuleSelection = {
  __typename: true,
  id: true,
  allocationLimit: true,
  allocationMethod: true,
  createdAt: true,
  customerSegmentPrerequisiteIds: true,
  customerSelection: true,
  endsAt: true,
  entitledCollectionIds: true,
  entitledCountryIds: true,
  entitledProductIds: true,
  entitledVariantIds: true,
  oncePerCustomer: true,
  prerequisiteCollectionIds: true,
  prerequisiteCustomerIds: true,
  prerequisiteProductIds: true,
  prerequisiteQuantityRange: true,
  prerequisiteShippingPriceRange: true,
  prerequisiteSubtotalRange: true,
  prerequisiteToEntitlementPurchase: true,
  prerequisiteToEntitlementQuantityRatio: true,
  prerequisiteVariants: true,
  shopId: true,
  shopifyCreatedAt: true,
  shopifyUpdatedAt: true,
  startsAt: true,
  targetSelection: true,
  targetType: true,
  title: true,
  updatedAt: true,
  usageLimit: true,
  value: true,
  valueType: true
};
const modelApiIdentifier = "shopifyPriceRule";
const pluralModelApiIdentifier = "shopifyPriceRules";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyPriceRuleSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyPriceRuleSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyPriceRuleSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyPriceRuleSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyPriceRuleSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyPriceRuleSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyPriceRuleSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createShopifyPriceRule",
    operationReturnType: "CreateShopifyPriceRule",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      shopifyPriceRule: { required: false, type: "CreateShopifyPriceRuleInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShopifyPriceRuleSelection
  },
  {
    type: "action",
    operationName: "bulkCreateShopifyPriceRules",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateShopifyPriceRulesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultShopifyPriceRuleSelection
  },
  {
    type: "action",
    operationName: "updateShopifyPriceRule",
    operationReturnType: "UpdateShopifyPriceRule",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      shopifyPriceRule: { required: false, type: "UpdateShopifyPriceRuleInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShopifyPriceRuleSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateShopifyPriceRules",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateShopifyPriceRulesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultShopifyPriceRuleSelection
  },
  {
    type: "action",
    operationName: "deleteShopifyPriceRule",
    operationReturnType: "DeleteShopifyPriceRule",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteShopifyPriceRules",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertShopifyPriceRule",
    operationReturnType: "UpsertShopifyPriceRule",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      shopifyPriceRule: { required: false, type: "UpsertShopifyPriceRuleInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateShopifyPriceRuleResult": { hasReturnType: false },
      "... on UpdateShopifyPriceRuleResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShopifyPriceRuleSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertShopifyPriceRules",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertShopifyPriceRulesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultShopifyPriceRuleSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shopifyPriceRuleGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ShopifyPriceRuleManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyPriceRuleSelection,
  operations
);
export {
  DefaultShopifyPriceRuleSelection,
  ShopifyPriceRuleManager
};
//# sourceMappingURL=ShopifyPriceRule.js.map
